<template>

    <div class="popup active">
        <div class="notice_popup human int">
            <div class="close">
                <img src="/images/close.png" alt="닫기" @click="$emit('close', false)"/>
            </div>
            
			<div class="tit">가입 검토 결과 안내</div>

            <div class="prj_name">
                <span class="name" title="">{{noti}}</span>
            </div>
			<div class="member">회원가입 승인이 반려되었습니다.<br/>추가 협의가 필요하신 경우 고객센터로 문의바랍니다.</div>
            <div class="select-btn">
                <div class="btn" @click="move()">탈퇴하기</div>
				<div class="btn" @click="$emit('close', false)">확인</div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

	components : {		
	},

	props: ['param'],

	data() {
		return {
			noti : this.param.noti,
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		move() {
			this.$emit('close', true);
			this.$router.push({name: 'MEM002M08', params : {id : this.param.id, password : this.param.password}});
		}
	},
};
</script>
